function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { find, findLastIndex, filter, merge } from 'lodash';
import Card from '../card/card';
import { waitForDomUpdate } from '../utils/dom-update-delay';
var CARDS_UPDATE_INTERVAL = 100;
var SLIDER_INTERVAL = 6000;
var CARD_ANIMATION_TIME = 1000;
var CARD_CLOSE_DELAY = 500;

var CardsManager = /*#__PURE__*/function () {
  function CardsManager(_ref) {
    var eventEmitter = _ref.eventEmitter,
        engine = _ref.engine,
        cardsContainer = _ref.cardsContainer,
        cardsConfig = _ref.cardsConfig;
    this.eventEmitter = eventEmitter;
    this.engine = engine;
    this.cardsContainer = cardsContainer;
    this.cardsConfig = cardsConfig;
    this.availableCards = [];
    this.activeCards = [];
    this.isAnimationEnabled = true;
    this.timeouts = [];
    this.disableAnimationRequestsCount = 0;
    this.previousSeekPosition = 0;
    this._updateCardsState = this._updateCardsState.bind(this);
    this.updateCardsOnTimeChange = this.updateCardsOnTimeChange.bind(this);
    this.slideNextCard = this.slideNextCard.bind(this);
    this.handleCardSizeChange = this.handleCardSizeChange.bind(this);
    this.cardsConfig.onChange(this.handleConfigChange, this);
    /**
     * Sometimes player can trigger play state and run `handleVideoPlayStart` right before destroying.
     * So it will schedule `updateCardsOnTimeChange` and because of asynchronous nature of last one,
     * `destroy` method can be called in the *middle* of execution of `updateCardsOnTimeChange` sequence.
     *
     * As a result, we will receive errors related to deleted properties of `CardsManager`.
     * As an example - 'Cannot read property 'getSize' of undefined'
     * in `_checkIfMoreCardsCanBeShown`
     */

    this.isDestroyed = false;
  }

  var _proto = CardsManager.prototype;

  _proto.addCard = /*#__PURE__*/function () {
    var _addCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cardData) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this._disableAnimation();

            case 2:
              this._createCard(cardData);

              this._clearActiveCards();

              _context.next = 6;
              return this._updateCardsState();

            case 6:
              this._enableAnimation();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function addCard(_x) {
      return _addCard.apply(this, arguments);
    }

    return addCard;
  }();

  _proto.addCards = /*#__PURE__*/function () {
    var _addCards = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cardsData) {
      var _this = this;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this._disableAnimation();

            case 2:
              cardsData.forEach(function (card) {
                return _this._createCard(card);
              });

              this._clearActiveCards();

              _context2.next = 6;
              return this._updateCardsState();

            case 6:
              this._enableAnimation();

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function addCards(_x2) {
      return _addCards.apply(this, arguments);
    }

    return addCards;
  }();

  _proto.removeCard = /*#__PURE__*/function () {
    var _removeCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
      var cardToRemove;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this._disableAnimation();

            case 2:
              cardToRemove = find(this.availableCards, {
                id: id
              });

              if (cardToRemove) {
                _context3.next = 6;
                break;
              }

              this._enableAnimation();

              return _context3.abrupt("return");

            case 6:
              this.availableCards.splice(this.availableCards.indexOf(cardToRemove), 1);
              _context3.next = 9;
              return this._disableCards([cardToRemove]);

            case 9:
              this._enableAnimation();

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function removeCard(_x3) {
      return _removeCard.apply(this, arguments);
    }

    return removeCard;
  }();

  _proto.updateCards = /*#__PURE__*/function () {
    var _updateCards = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cards) {
      var _this2 = this;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this._disableAnimation();

            case 2:
              cards.forEach(function (card) {
                var id = card.id,
                    from = card.from,
                    to = card.to,
                    order = card.order;
                var cardToUpdate = find(_this2.availableCards, {
                  id: id
                });
                merge(cardToUpdate, {
                  from: from / 1000,
                  to: to / 1000,
                  order: order
                });
              });

              this._sortCards();

              _context4.next = 6;
              return this._clearActiveCards();

            case 6:
              _context4.next = 8;
              return this._updateCardsState();

            case 8:
              this._enableAnimation();

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function updateCards(_x4) {
      return _updateCards.apply(this, arguments);
    }

    return updateCards;
  }();

  _proto.clearCards = function clearCards() {
    this.cardsContainer.removeCardNodes(this.availableCards);
    this.availableCards = [];
    this.activeCards = [];
  };

  _proto._createCard = function _createCard(cardData) {
    var card = new Card(_objectSpread(_objectSpread({}, cardData), {}, {
      cardsConfig: this.cardsConfig,
      eventEmitter: this.eventEmitter
    }));
    this.availableCards.push(card);

    this._sortCards();
  };

  _proto._sortCards = function _sortCards() {
    this.availableCards.sort(function (card1, card2) {
      if (card1.from === card2.from) {
        return card1.order - card2.order;
      }

      return card1.from - card2.from;
    });
  };

  _proto.handleVideoPlayStart = function handleVideoPlayStart() {
    this.stopTracking();
    this.startTracking();
    this.startSlider();
  };

  _proto.handleVideoPlayPause = function handleVideoPlayPause() {
    this.stopTracking();
    this.stopSlider();
  };

  _proto.updateCardsOnTimeChange = function updateCardsOnTimeChange() {
    return this._updateCardsState();
  };

  _proto.handleSeekPositionChange = /*#__PURE__*/function () {
    var _handleSeekPositionChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var currentTime;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              currentTime = this.engine.getCurrentTime();

              if (!(currentTime === this.previousSeekPosition)) {
                _context5.next = 3;
                break;
              }

              return _context5.abrupt("return");

            case 3:
              this.previousSeekPosition = currentTime;

              this._cancelDeferredUpdates();

              _context5.next = 7;
              return this._disableAnimation();

            case 7:
              _context5.next = 9;
              return this._updateCardsState();

            case 9:
              this._enableAnimation();

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function handleSeekPositionChange() {
      return _handleSeekPositionChange.apply(this, arguments);
    }

    return handleSeekPositionChange;
  }();

  _proto.handleCardClose = function handleCardClose(card) {
    if (!this.cardsConfig.isPreviewMode) {
      this._closeCard(card);
    }
  };

  _proto.handlePlayerSizeChange = /*#__PURE__*/function () {
    var _handlePlayerSizeChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              this._cancelDeferredUpdates();

              _context6.next = 3;
              return this._disableAnimation();

            case 3:
              this.resetSliderInterval();

              this._hideNotFittingCards();

              _context6.next = 7;
              return this._checkIfMoreCardsCanBeShown();

            case 7:
              _context6.next = 9;
              return this._updateCardsPositions();

            case 9:
              this._enableAnimation();

            case 10:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function handlePlayerSizeChange() {
      return _handlePlayerSizeChange.apply(this, arguments);
    }

    return handlePlayerSizeChange;
  }();

  _proto.handleCardSizeChange = function handleCardSizeChange() {
    this._hideNotFittingCards();

    this._updateCardsPositions();
  };

  _proto.handleConfigChange = /*#__PURE__*/function () {
    var _handleConfigChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this._disableAnimation();

            case 2:
              this._clearActiveCards();

              _context7.next = 5;
              return this._updateCardsState();

            case 5:
              this._enableAnimation();

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function handleConfigChange() {
      return _handleConfigChange.apply(this, arguments);
    }

    return handleConfigChange;
  }() // Cards update on time change
  ;

  _proto._updateCardsState =
  /*#__PURE__*/
  function () {
    var _updateCardsState2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var currentTime, cardsToDisable, cardsToEnable;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              currentTime = this.engine.getCurrentTime();
              cardsToDisable = this.availableCards.filter(function (card) {
                return card.isActive && !card.shouldBeActiveAt(currentTime);
              });
              _context8.next = 4;
              return this._disableCards(cardsToDisable);

            case 4:
              cardsToEnable = this.availableCards.filter(function (card) {
                return !card.isActive && card.shouldBeActiveAt(currentTime);
              });
              _context8.next = 7;
              return this._enableCards(cardsToEnable);

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function _updateCardsState() {
      return _updateCardsState2.apply(this, arguments);
    }

    return _updateCardsState;
  }();

  _proto._disableCards = /*#__PURE__*/function () {
    var _disableCards2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(cards) {
      var _this3 = this;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (cards.length) {
                _context9.next = 2;
                break;
              }

              return _context9.abrupt("return", Promise.resolve());

            case 2:
              this._removeCardsFromActive(cards);

              this._defer(function () {
                return _this3.cardsContainer.removeCardNodes(cards);
              }, CARD_ANIMATION_TIME);

              _context9.next = 6;
              return waitForDomUpdate();

            case 6:
              _context9.next = 8;
              return this._checkIfMoreCardsCanBeShown();

            case 8:
              _context9.next = 10;
              return this._updateCardsPositions();

            case 10:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function _disableCards(_x5) {
      return _disableCards2.apply(this, arguments);
    }

    return _disableCards;
  }();

  _proto._enableCards = /*#__PURE__*/function () {
    var _enableCards2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(cards) {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              if (cards.length) {
                _context10.next = 2;
                break;
              }

              return _context10.abrupt("return", Promise.resolve());

            case 2:
              this._addCardsToActive(cards);

              _context10.next = 5;
              return this.cardsContainer.addCardNodes(cards);

            case 5:
              _context10.next = 7;
              return this._showCards(cards);

            case 7:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function _enableCards(_x6) {
      return _enableCards2.apply(this, arguments);
    }

    return _enableCards;
  }();

  _proto._addCardsToActive = function _addCardsToActive(cards) {
    var _this$activeCards;

    cards.forEach(function (card) {
      return card.isActive = true;
    }); // insert cards after last visible card

    var insertPosition = findLastIndex(this.activeCards, 'isVisible') + 1;

    (_this$activeCards = this.activeCards).splice.apply(_this$activeCards, [insertPosition, 0].concat(cards));
  };

  _proto._removeCardsFromActive = function _removeCardsFromActive(cards) {
    var _this4 = this;

    cards.forEach(function (card) {
      _this4._hideCard(card);

      card.isActive = false;

      _this4.activeCards.splice(_this4.activeCards.indexOf(card), 1);
    });
  };

  _proto._clearActiveCards = function _clearActiveCards() {
    this._removeCardsFromActive([].concat(this.activeCards));
  } // Sliding cards if they don't fit player size
  ;

  _proto.startSlider = function startSlider() {
    if (this.sliderInterval) {
      return;
    }

    this.sliderInterval = setInterval(this.slideNextCard, SLIDER_INTERVAL);
  };

  _proto.stopSlider = function stopSlider() {
    clearInterval(this.sliderInterval);
    this.sliderInterval = null;
  };

  _proto.startTracking = function startTracking() {
    this.trackingInterval = setInterval(this.updateCardsOnTimeChange, CARDS_UPDATE_INTERVAL);
  };

  _proto.stopTracking = function stopTracking() {
    clearInterval(this.trackingInterval);
    this.trackingInterval = null;
  };

  _proto.resetSliderInterval = function resetSliderInterval() {
    if (!this.sliderInterval) {
      return;
    }

    this.stopSlider();
    this.startSlider();
  };

  _proto.slideNextCard = function slideNextCard() {
    var _this5 = this;

    // show more cards from the left if there is free space
    this._defer(function () {
      _this5._checkIfMoreCardsCanBeShown();
    }, CARD_ANIMATION_TIME);

    return this._showNextCard();
  } // Manage active cards
  ;

  _proto._showCards =
  /*#__PURE__*/
  function () {
    var _showCards2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(cards) {
      var _this6 = this;

      var cardsToShow;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (cards === void 0) {
                cards = [];
              }

              cardsToShow = this._limitToContainerSize(cards);

              this._hideNotFittingCards(cardsToShow);

              this._sortCardNodes(cardsToShow);

              _context11.next = 6;
              return waitForDomUpdate();

            case 6:
              _context11.next = 8;
              return this._prepareCardsToShow(cardsToShow);

            case 8:
              cardsToShow.forEach(function (card) {
                return _this6._showCard(card);
              });
              _context11.next = 11;
              return this._updateCardsPositions();

            case 11:
              _context11.next = 13;
              return waitForDomUpdate();

            case 13:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function _showCards(_x7) {
      return _showCards2.apply(this, arguments);
    }

    return _showCards;
  }();

  _proto._showCard = function _showCard(card) {
    card.show();
    card.addResizeHandler(this.handleCardSizeChange);
    this.resetSliderInterval();
  };

  _proto._hideCard = function _hideCard(card) {
    card.removeResizeHandler(this.handleCardSizeChange);
    card.hide();

    this._defer(function () {
      return card.setInitialPosition();
    }, CARD_ANIMATION_TIME);
  };

  _proto._sortCardNodes = function _sortCardNodes(cardsToShow) {
    // maintain nodes order in sync with visible order for accessibility
    var nextVisibleCardNodes = this.activeCards.filter(function (card) {
      return card.isVisible || cardsToShow.indexOf(card) !== -1;
    });
    this.cardsContainer.addCardNodes([].concat(nextVisibleCardNodes).reverse());
  };

  _proto._showNextCard = function _showNextCard() {
    var hasHiddenCards = filter(this.activeCards, ['isVisible', false]).length;

    if (!hasHiddenCards) {
      return;
    }

    var cardToShow = find(this.activeCards, ['isVisible', false]);
    return this._showCards([cardToShow]);
  };

  _proto._closeCard = function _closeCard(card) {
    var _this7 = this;

    this._removeCardsFromActive([card]);

    this._defer(function () {
      return _this7.cardsContainer.removeCardNode(card);
    }, CARD_ANIMATION_TIME);

    this._defer(function () {
      return _this7._fillGaps();
    }, CARD_CLOSE_DELAY);
  };

  _proto._fillGaps = /*#__PURE__*/function () {
    var _fillGaps2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this._checkIfMoreCardsCanBeShown();

            case 2:
              this._updateCardsPositions();

            case 3:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function _fillGaps() {
      return _fillGaps2.apply(this, arguments);
    }

    return _fillGaps;
  }();

  _proto._limitToContainerSize = function _limitToContainerSize(cards) {
    // reduce cards amount to fit container size
    var fittingCards = [];
    var containerSize = this.cardsContainer.getSize();
    var cardsTotalSize = 0;
    cards.forEach(function (newCard) {
      cardsTotalSize += newCard.getSize();

      if (cardsTotalSize < containerSize) {
        fittingCards.push(newCard);
      }
    });
    return fittingCards;
  };

  _proto._prepareCardsToShow = function _prepareCardsToShow(cards) {
    // for cards sliding from outside the screen
    var initialOffset = 0;
    cards.forEach(function (card) {
      card.setInitialPosition(initialOffset);
      initialOffset += card.getSize();
    });
    return waitForDomUpdate();
  };

  _proto._hideNotFittingCards = function _hideNotFittingCards(nextVisibleCards) {
    if (nextVisibleCards === void 0) {
      nextVisibleCards = [];
    }

    var containerSize = this.cardsContainer.getSize();
    var visibleCards = filter(this.activeCards, 'isVisible');
    var totalCardsSize = [].concat(visibleCards, nextVisibleCards).reduce(function (total, card) {
      return total + card.getSize();
    }, 0);

    while (totalCardsSize > containerSize) {
      var cardToHide = this.activeCards.shift();

      this._hideCard(cardToHide);

      this.activeCards.push(cardToHide);
      totalCardsSize -= cardToHide.getSize();
    }
  };

  _proto._checkIfMoreCardsCanBeShown = function _checkIfMoreCardsCanBeShown() {
    if (this.isDestroyed) {
      return;
    }

    var containerSize = this.cardsContainer.getSize();
    var cardsToShow = [];
    var nextTotalSize = 0;
    this.activeCards.forEach(function (card) {
      nextTotalSize += card.getSize();

      if (nextTotalSize < containerSize && !card.isVisible) {
        cardsToShow.push(card);
      }
    });

    if (!cardsToShow.length) {
      return Promise.resolve();
    }

    return this._showCards(cardsToShow);
  };

  _proto._updateCardsPositions = function _updateCardsPositions() {
    this.activeCards.filter(function (card) {
      return card.isVisible;
    }).reduceRight(function (offset, card) {
      card.updatePosition(offset);
      return offset + card.getSize();
    }, 0);
  } // Force card to be visible on screen
  ;

  _proto.showSelectedCard =
  /*#__PURE__*/
  function () {
    var _showSelectedCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(id) {
      var selectedCard;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this._disableAnimation();

            case 2:
              selectedCard = find(this.activeCards, {
                id: id
              });

              if (!(!selectedCard || selectedCard.isVisible)) {
                _context13.next = 6;
                break;
              }

              this._enableAnimation();

              return _context13.abrupt("return");

            case 6:
              if (selectedCard.isVisible) {
                _context13.next = 11;
                break;
              }

              _context13.next = 9;
              return this._showNextCard();

            case 9:
              _context13.next = 6;
              break;

            case 11:
              this._enableAnimation();

            case 12:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function showSelectedCard(_x8) {
      return _showSelectedCard.apply(this, arguments);
    }

    return showSelectedCard;
  }();

  _proto._enableAnimation = /*#__PURE__*/function () {
    var _enableAnimation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              this.disableAnimationRequestsCount -= 1;

              if (!(this.disableAnimationRequestsCount === 0)) {
                _context14.next = 5;
                break;
              }

              this.isAnimationEnabled = true;
              _context14.next = 5;
              return this.cardsContainer.enableAnimation();

            case 5:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    function _enableAnimation() {
      return _enableAnimation2.apply(this, arguments);
    }

    return _enableAnimation;
  }();

  _proto._disableAnimation = /*#__PURE__*/function () {
    var _disableAnimation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              this.disableAnimationRequestsCount += 1;
              this.isAnimationEnabled = false;
              _context15.next = 4;
              return this.cardsContainer.disableAnimation();

            case 4:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));

    function _disableAnimation() {
      return _disableAnimation2.apply(this, arguments);
    }

    return _disableAnimation;
  }();

  _proto._defer = function _defer(callback, delay) {
    var timeoutValue = this.isAnimationEnabled ? delay : 0;
    this.timeouts.push(setTimeout(callback, timeoutValue));
  };

  _proto._cancelDeferredUpdates = function _cancelDeferredUpdates() {
    this.timeouts.forEach(function (timeout) {
      return clearTimeout(timeout);
    });
  };

  _proto.destroy = function destroy() {
    this.isDestroyed = true;
    this.stopTracking();
    this.stopSlider();

    this._cancelDeferredUpdates();

    delete this.cardsContainer;
  };

  return CardsManager;
}();

export { CardsManager as default };